module.exports = __webpack_public_path__ + "static/media/6.40a820d4.jpg";